import { render } from "./product-gallery.vue?vue&type=template&id=7f471c7c"
import script from "./product-gallery.vue?vue&type=script&lang=js"
export * from "./product-gallery.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/maskingruppen-new/maskingruppen-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__